import { render, staticRenderFns } from "./processfnf.vue?vue&type=template&id=71f3a7a6&scoped=true"
import script from "./processfnf.vue?vue&type=script&lang=js"
export * from "./processfnf.vue?vue&type=script&lang=js"
import style0 from "./processfnf.vue?vue&type=style&index=0&id=71f3a7a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f3a7a6",
  null
  
)

export default component.exports